<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            mode="vertical"
            class="el-menu-vertical"
        >
            <router-link to="/">
                <li class="el-menu-item logo">
                    <svg-icon icon-class="logo" />
                </li>
            </router-link>
            <sidebar-item
                v-for="route in routes"
                :key="route.path"
                :item="route"
                :base-path="route.path"
            />
        </el-menu>
    </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
export default {
    components: { SidebarItem },
    computed: {
        ...mapGetters(["sidebar", "permission_routers"]),
        routes() {
            return this.$store.state.permission.routes;
        },
        isCollapse() {
            return !this.sidebar.opened;
        }
    }
};
</script>

<style lang="sass">
.el-menu-vertical:not(.el-menu--collapse)
    min-height: 100vh
</style>
